import { useCallback } from 'react'
import {
  getScheduleReliabilityReport,
  type ReportBucketType,
  type ScheduleReliabilityReportResult,
} from '@services/api/reports/engagement.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type ScheduleReliabilityData = ScheduleReliabilityReportResult

export type UseScheduleReliabilityResult = {
  loading: boolean
  error: string | null
  data: ScheduleReliabilityData | null
  bucketLabel: string
}

export function useScheduleReliability(
  toolbarSelection: Record<string, string>,
): UseScheduleReliabilityResult {
  const getBucketFromData = useCallback(
    (data: ScheduleReliabilityReportResult): ReportBucketType =>
      data.noShowCancellationTrend.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getScheduleReliabilityReport,
    getBucketFromData,
    errorMessage: 'Failed to load schedule reliability data',
  })
}
